module.exports = __webpack_public_path__ + "img/icon-3.79365bba.png";